const blocks = document.querySelectorAll('.block-financing-calculator');

if (blocks.length > 0) {
	blocks.forEach((block) => {
		const mapImage = block.querySelector(
			'.block-financing-calculator__map-image'
		);

		if (!mapImage) {
			return;
		}

		let currentX = 0;
		let currentY = 0;
		let targetX = 0;
		let targetY = 0;
		let frameId = null;

		const moveAmount = 60;

		const animate = () => {
			currentX += (targetX - currentX) * 0.08;
			currentY += (targetY - currentY) * 0.08;

			mapImage.style.transform = `translate3d(${currentX}px, ${currentY}px, 0) scale(1.08)`;

			frameId = requestAnimationFrame(animate);
		};

		const startAnimation = () => {
			if (!frameId) {
				frameId = requestAnimationFrame(animate);
			}
		};

		const stopAnimation = () => {
			if (frameId) {
				cancelAnimationFrame(frameId);
				frameId = null;
			}
		};

		block.addEventListener('mouseenter', () => {
			startAnimation();
		});

		block.addEventListener('mousemove', (event) => {
			const rect = block.getBoundingClientRect();

			const x = event.clientX - rect.left;
			const y = event.clientY - rect.top;

			const centerX = rect.width / 2;
			const centerY = rect.height / 2;

			targetX = ((x - centerX) / centerX) * moveAmount;
			targetY = ((y - centerY) / centerY) * moveAmount;
		});

		block.addEventListener('mouseleave', () => {
			targetX = 0;
			targetY = 0;

			const reset = () => {
				currentX += (targetX - currentX) * 0.08;
				currentY += (targetY - currentY) * 0.08;

				mapImage.style.transform = `translate3d(${currentX}px, ${currentY}px, 0) scale(1.08)`;

				if (Math.abs(currentX) < 0.1 && Math.abs(currentY) < 0.1) {
					mapImage.style.transform =
						'translate3d(0, 0, 0) scale(1.08)';
					stopAnimation();
					return;
				}

				frameId = requestAnimationFrame(reset);
			};

			stopAnimation();
			frameId = requestAnimationFrame(reset);
		});
	});
}
